import Studios from '@/modules/Studios/pages/StudiosPage.vue'
import Studio from '@/modules/Studios/pages/StudioPage.vue'
import CreateStudio from '@/modules/Studios/pages/CreateStudio.vue'
import StudioSettings from '@/modules/Studios/pages/StudioSettingsPage.vue'
import StudioSettingsGeneral from '@/modules/Studios/components/settings/StudioSettingsGeneral.vue'
import StudioSettingsAdmins from '@/modules/Studios/components/settings/StudioSettingsAdmins.vue'
import StudioSettingsTeachers from '@/modules/Studios/components/settings/StudioSettingsTeachers.vue'
import StudioSettingsSocials from '@/modules/Studios/components/settings/StudioSettingsSocials.vue'
import StudioSettingsStudents from '@/modules/Studios/components/settings/StudioSettingsStudents.vue'

export default [
  {
    path: '/studios',
    name: 'Studios',
    component: Studios,
  },
  {
    path: '/create-studio/:id',
    name: 'CreateStudio',
    component: CreateStudio,
  },
  {
    path: '/studio/:id',
    name: 'Studio',
    component: Studio,
  },
  {
    path: '/studio/:id/settings',
    name: 'StudioSettings',
    component: StudioSettings,
    children: [
      {
        path: 'general',
        component: StudioSettingsGeneral,
        name: 'StudioSettingsGeneral',
        meta: { title: 'General Info' },
      },
      {
        path: 'admins',
        component: StudioSettingsAdmins,
        name: 'StudioSettingsAdmins',
        meta: { title: 'Admins' },
      },
      {
        path: 'teachers',
        component: StudioSettingsTeachers,
        name: 'StudioSettingsTeachers',
        meta: { title: 'Teachers' },
      },
      {
        path: 'students',
        component: StudioSettingsStudents,
        name: 'StudioSettingsStudents',
        meta: { title: 'Students' },
      },
      {
        path: 'socials',
        component: StudioSettingsSocials,
        name: 'StudioSettingsSocials',
        meta: { title: 'Social' },
      },
    ],
  },
]
